export interface DirectoryMarketingContentSection {
  id: string;
  spotlight_directory_id: number;
  content_type: MarketingContentType;
  config: MarketingContentConfig[];
  visible: boolean;
  allow_dismiss: boolean;
  updated_at: string;
}

export type MarketingContentType = 'announcement_bar' | 'hero_banner' | 'carousel';

export interface MarketingContentConfig {
  type: MarketingContentConfigType;

  // announcement_bar / text
  background_color?: string;
  color?: string;
  content?: string;

  // hero_banner / banner_image
  image_url?: string;
  mobile_image_url?: string;
  banner_link?: string;

  // carousel / featured_recipients
  heading?: string;
  sort_by?: MarketingContentFeaturedRecipientsSortBy;
  limit?: number;
}

export enum MarketingContentConfigType {
  TEXT = 'text',
  BANNER_IMAGE = 'banner_image',
  FEATURED_RECIPIENTS = 'featured_recipients',
}

export enum MarketingContentFeaturedRecipientsSortBy {
  MOST_RECENT = 'most_recent',
  MOST_COMPLETED = 'most_completed',
  MOST_EARNED_CREDENTIALS = 'most_earned_credentials',
  RANDOM = 'random',
}
